import { memo } from "react";

import { StackOutput } from "types/generated";
import TableSimple from "ds/components/TableSimple";

import useTemplateDeploymentOutputsTableStore from "./useTemplateDeploymentOutputsTableStore";
import { TEMPLATE_DEPLOYMENT_OUTPUTS_TABLE_CELLS } from "./Cells";

type OutputWithStack = StackOutput & {
  stackId: string;
  stackName: string;
  uniqueId: string;
};

type TemplateDeploymentOutputsTableProps = {
  outputs: OutputWithStack[];
};

const TemplateDeploymentOutputsTable = ({ outputs }: TemplateDeploymentOutputsTableProps) => {
  return (
    <TableSimple
      data={outputs}
      store={useTemplateDeploymentOutputsTableStore}
      ariaLabel="Template deployment outputs table"
      cellPerColumn={TEMPLATE_DEPLOYMENT_OUTPUTS_TABLE_CELLS}
      itemIdKey="uniqueId"
    />
  );
};

export default memo(TemplateDeploymentOutputsTable);
